import { useEffect, useRef, useState } from "react";

interface McpAppFrameProps {
  html: string;
  title: string;
  toolResult: unknown;
}

export function McpAppFrame({ html, title, toolResult }: McpAppFrameProps) {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [height, setHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    function handleMessage(event: MessageEvent) {
      if (event.source !== iframe?.contentWindow) return;
      if (event.data?.type === "ui/initialize") {
        iframe?.contentWindow?.postMessage(
          { type: "ui/tool_result", result: { content: toolResult } },
          "*"
        );
      }
      if (event.data?.type === "ui/height" && typeof event.data.height === "number") {
        setHeight(event.data.height);
      }
    }

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [toolResult]);

  return (
    <iframe
      ref={iframeRef}
      srcDoc={html}
      sandbox="allow-scripts"
      style={{
        width: "100%",
        height: height ?? "auto",
        border: "none",
        borderRadius: 8,
        display: "block",
      }}
      title={title}
    />
  );
}
